import React, { PureComponent } from 'react'
import {
  Col,
  FormGroup,
  Input,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap'
import axios from 'axios'
import Alert from '../../Widgets/Alert'
import withAlertTimeout from '../../../HOCs/withAlertTimeout'

class AddCategory extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      newCategoryName: '',
      isCreatingCategory: false
    }
    this.onCategoryNameInput = this.onCategoryNameInput.bind(this)
    this.createCategory = this.createCategory.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
  }

  componentDidMount() {
    document.querySelector('#add-category-input').focus()
  }

  onCategoryNameInput(e) {
    this.setState({ newCategoryName: e.target.value })
  }

  onKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault()
      e.stopPropagation()
      this.createCategory()
    }
  }

  createCategory() {
    if (this.state.newCategoryName.length) {
      const token = sessionStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }
      this.setState({ isCreatingCategory: true })
      axios
        .post(
          '/api/proxy/v2/categories',
          { categoryName: this.state.newCategoryName },
          { headers }
        )
        .then(({ data }) => {
          this.setState({ newCategoryName: '', isCreatingCategory: false })
          this.props.refresh()
          this.props.showSuccess()
        })
        .catch(err => {
          console.log(err)
          this.setState({ isCreatingCategory: false })
          this.props.showFailure()
        })
    }
  }

  render() {
    return (
      <Card>
        {<Alert active={this.props.success} message="Category Created" />}
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <CardHeader>Add a Category</CardHeader>
        <CardBody>
          <Col md="6" xs="12">
            <FormGroup>
              <Label htmlFor="new category">Category Name</Label>
              <Input
                type="text"
                id="add-category-input"
                value={this.state.newCategoryName}
                onKeyPress={this.onKeyPress}
                onChange={this.onCategoryNameInput}
              />
            </FormGroup>
            <Button
              style={{ float: 'right' }}
              type="submit"
              color="primary"
              onClick={this.createCategory}
              disabled={!this.state.newCategoryName.length}
            >
              {this.state.isCreatingCategory && (
                <i
                  className="fa fa-circle-o-notch fa-spin"
                  style={{ marginRight: 5 }}
                />
              )}
              Submit
            </Button>
          </Col>
        </CardBody>
      </Card>
    )
  }
}

export default withAlertTimeout(AddCategory)



// WEBPACK FOOTER //
// ./src/views/Pages/Categories/AddCategory.js